import http from "./httpService";

export default {
    labels() {
        return http.get("/tags/labels");
    },

    /**
     *
     * @param {number} uid
     * @returns {Promise<any>}
     */
    userLabels(uid) {
        return http.get(`/user/${uid}/labels`);
    },

    /**
     *
     * @param {number} uid
     * @param {string[]} labels
     * @returns {Promise<any>}
     */
    addUserLabel(uid, labels) {
        return http.post(`/user/${uid}/labels`, {label: labels});
    },

    /**
     *
     * @param {number} uid
     * @param {string[]} term_id
     * @returns {Promise<any>}
     */
    removeUserLabel(uid, term_id) {
        return http.post(`/user/${uid}/labels/remove`, {term_id});
    },
}
